<template>
	<div style="box-sizing: border-box;padding: 10px;min-height: 100%;" v-loading="loading">
		<v-jstree ref="jstree" size="small" text-field-name="name" value-field-name="id" :data="settlementtasklist"
			collapse @item-click="itemClick" v-if="settlementtasklist.length!=0"></v-jstree>
	</div>
</template>
<style scoped>


</style>
<script>
	import VJstree from 'vue-jstree'
	export default {
		props: {
			defaulttime: {
				default: () => {
					return null
				}
			},
		},
		data() {
			return {
				loading: false,
				settlementtasklist: [],
				settlementtasksource: [],
				currentObj: null,
				currentItem: {
					id: 0,
					name: ''
				},
				currentChildren: [],
			}
		},
		created() {
			this.list()
		},
		mounted() {

		},
		watch: {

		},
		computed: {

		},

		methods: {
			list() {
				// 获取当前日期
				const now = this.$Moment();

				// 获取当前年份和月份
				const currentYear = now.year();
				const currentMonth = now.month() + 1; // moment.js 月份也是0-11

				// 创建空数组存储树形数据
				const treeData = [];

				// 循环从2024年到当前年份
				for (let year = 2025; year <= currentYear; year++) {
					// 创建年份节点
					const yearNode = {
						id: `year_${year}`,
						parent: "#",
						name: year.toString(),
						children: []
					};

					// 如果是当前年份，则结束月份为当前月份，否则为12月
					const endMonth = (year === currentYear) ? currentMonth : 12;

					// 循环月份
					for (let month = 1; month <= endMonth; month++) {
						// 使用moment获取月初时间戳
						const firstDayOfMonthTimestamp = this.$Moment(`${year}-${month}`, "YYYY-MM")
							.startOf('month')
							.valueOf();

						// 创建月份节点
						const monthNode = {
							id: firstDayOfMonthTimestamp,
							parent: `year_${year}`,
							name: `${month}月`,
							selected:this.defaulttime == firstDayOfMonthTimestamp
						};

						// 将月份节点添加到年份节点
						yearNode.children.push(monthNode);
					}

					// 将年份节点添加到树数据
					treeData.push(yearNode);
				}

				this.settlementtasklist = treeData;
			},
			itemClick(node, item, e) {
				this.$emit('select', {
					id: item.id,
					name: item.name,
					parentid: item.parentid,
					childrenid: item.childrenid,
					settlementtasksource: this.settlementtasksource

				})
				e.stopPropagation()
			},
			updateNode(node) {
				for (let i in node) {
					this.currentItem[i] = node[i]
				}
			},
			addNode(node) {
				this.currentItem.addChild(node)
			},
			removeNode() {
				let index = this.currentObj.parentItem.indexOf(this.currentItem)
				this.currentObj.parentItem.splice(index, 1)
			},
			unSelectNode() {
				this.currentItem.selected = false
				this.currentItem = {
					id: 0,
					name: ''
				}
			},
			timestampToYear(timestamp) {
				let date = new Date(timestamp)
				let year = date.getFullYear()
				return year
			}
		},
		components: {
			VJstree
		}
	}
</script>